import { createRouter, createWebHistory, RouteMeta, RouteRecordRaw } from 'vue-router'
import BlankPage from '../views/BlankPage.vue'
import HomeView from '../views/HomeView.vue'
import Login from '../views/Login.vue'
import MemberJoin from '../views/MemberJoin.vue'
import JoinAgree from '../views/JoinAgree.vue'
import EmailAuth from '../views/EmailAuth.vue'
import JoinEnd from '../views/JoinEnd.vue'
import PasswordReset from '../views/PasswordReset.vue'
import PasswordResetResult from '../views/PasswordResetResult.vue'
import ResetPassword from '../views/ResetPassword.vue'
import ResetPasswordResult from '../views/ResetPasswordResult.vue'
import BoardWrite from '../views/BoardWrite.vue'
import BoardView from '../views/BoardView.vue'




const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      "title": "KCK Doc Center",
    } as RouteMeta
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: {
      "title": "KCK Doc Center Login",
    } as RouteMeta

  },
  {
    path: '/MemberJoin',
    name: 'MemberJoin',
    component: MemberJoin,
    meta: {
      "title": "KCK Doc Center1",
    } as RouteMeta

  },
  {
    path: '/JoinAgree',
    name: 'JoinAgree',
    component: JoinAgree,
    meta: {
      "title": "test_title",
    }
  },
  {
    path: '/EmailAuth',
    name: 'EmailAuth',
    component: EmailAuth,
    meta: {
      "title": "EmailAuth",
    }
  },

  {
    path: '/JoinEnd',
    name: 'JoinEnd',
    component: JoinEnd,
    meta: {
      "title": "JoinEnd",
    }
  },

  {
    path: '/PasswordReset',
    name: 'PasswordReset',
    component: PasswordReset,
    meta: {
      "title": "PasswordReset",
    }
  },
  {
    path: '/PasswordResetResult',
    name: 'PasswordResetResult',
    component: PasswordResetResult,
    meta: {
      "title": "PasswordResetResult",
    }
  },

  {
    path: '/resetPassword/:guid',
    name: 'resetPassword',
    component: ResetPassword,
    meta: {
      "title": "resetPassword",
    }
  },

  {
    path: '/ResetPasswordResult',
    name: 'ResetPasswordResult',
    component: ResetPasswordResult,
    meta: {
      "title": "ResetPasswordResult",
    }
  },

  {
    path: '/BoardWrite',
    name: 'BoardWrite',
    component: BoardWrite,
    meta: {
      "title": "BoardWrite",
    }
  },

  {
    path: '/v/:url_key',
    name: 'BoardView',
    component: BoardView,
    meta: {
      "title": "BoardView",
    }
  },

  


  

  
  {
    path: '/BlankPage',
    name: 'BlankPage',
    component: BlankPage,
    meta: {
      "title": "BlankPage",
    }
  },

  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/about2',
    name: 'about2',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});


export default router
